import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: "app-pag-500",
    templateUrl: "./pagina-500.component.html",
    styleUrls: ["./pagina-500.component.css"],
    standalone: false
})
export class Pagina500Component implements OnInit {
  constructor(public oRouter: Router) {}

  ngOnInit() {}
}
